export enum LaboratoryName {
  BIO_LAB = 'biolab',
  ADRIA_LAB = 'adrialab',
}
